import { render, staticRenderFns } from "./select-more.vue?vue&type=template&id=28509a44&scoped=true&"
import script from "./select-more.vue?vue&type=script&lang=js&"
export * from "./select-more.vue?vue&type=script&lang=js&"
import style0 from "./select-more.vue?vue&type=style&index=0&id=28509a44&scoped=true&lang=scss&"
import style1 from "./select-more.vue?vue&type=style&index=1&id=28509a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28509a44",
  null
  
)

export default component.exports